import React, { useState } from 'react';
import styles from './AddProducts.module.css';
import LoaderPage from '../LoaderPage/LoaderPage';
import CloseBtn from '../../elemets/CloseBtn/CloseBtn';
import Checkbox from '../../elemets/Checkbox/Checkbox';
import { addDocBd } from '../../firebase';
import { getProductObject } from '../../helperProject';
import SimilarData from '../SimilarData/SimilarData';

export default function AddProducts({ setPopup, productsArray, setProductsArray }) {
  const [loader, setLoader] = useState(false);
  const [showSimilarData, setShowSimilarData] = useState(false);

  // console.log(productsArray);

  const [productObject, setProductObject] = useState(getProductObject());

  const addProduct = async (productObject) => {
    setLoader(true);

    if (!productObject.productText) {
      window.alert('Заповніть Назву продукта!');
      setLoader(false);
      return;
    }

    const data = {
      ...productObject,
      productText: productObject.productText.trim(),
    };

    const isAddProductBd = await addDocBd('products', data.id, data);
    if (isAddProductBd) {
      data.newProduct = true;

      setProductsArray([data, ...productsArray]);
      alert('Товар додано успішно.');
    }
    setPopup(false);
    setLoader(false);
  };

  const onChangeInputProductName = (productObject, value) => {
    setProductObject({ ...productObject, productText: value });

    if (!showSimilarData) {
      setShowSimilarData(true);
    }
  };
  return (
    <>
      <div className={styles.popup_wrapper}>
        <div className={styles.popup_contnent_wrapper}>
          <div className={styles.popup_contnent_fon}>
            <button className={styles.popup_close_btn}>
              <CloseBtn handleClick={setPopup} />
            </button>
            Назва продукта
            <div className={styles.popup_input_wrapper}>
              <input
                className={
                  productObject.productText
                    ? styles.popup_input
                    : styles.popup_input + ' ' + styles.popup_input_error
                }
                type="text"
                value={productObject.productText}
                onChange={(e) => onChangeInputProductName(productObject, e.target.value)}
              />
              {showSimilarData && (
                <SimilarData
                  searchArray={productsArray}
                  itemSearch="productText"
                  textSearch={productObject.productText}
                  handleClick={setShowSimilarData}
                  smallText_1=""
                  smallText_2="unitBasket"
                />
              )}
            </div>
            <div className={styles.popup_add_btn_wrapper}>
              <button className={styles.popup_add_btn} onClick={() => addProduct(productObject)}>
                Додати
              </button>
            </div>
          </div>
        </div>
      </div>
      {loader && <LoaderPage />}
    </>
  );
}
